exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.global-menu[data-v-a22165a0] {\n  width: 100%;\n}\n@media screen and (min-width: 1024px) {\n.global-menu[data-v-a22165a0] {\n    width: calc(100% - 11rem);\n}\n.global-tenant-menu[data-v-a22165a0] {\n    width: calc(100% - 21rem);\n}\n}\n", ""]);

// exports
